import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
// Reception 
import ReceptionDashboardPage from '../app/reception/dashboard/pages/ReceptionDashboardPage'
import ReceptionCheckinPage from '../app/reception/patient/pages/ReceptionCheckinPage'
import TokenPaymentPage from '../app/reception/patient/pages/TokenPaymentPage'
import GatepassDashboardPage from '../app/gatepass/dashboard/pages/GatepassDashboardPage'
import GatepassGeneratePage from '../app/gatepass/visitor/pages/GatepassGeneratePage'
import GatepassDetailsPage from '../app/gatepass/visitor/pages/GatepassDetailsPage'
import GatepassVisitorListPage from '../app/gatepass/visitor/pages/GatepassVisitorListPage'

import ReceptionCollectionReportPage from '../app/reception/reports/pages/ReceptionCollectionReportPage'
import ReceptionScheduleCheckinPage from '../app/reception/patient/pages/ReceptionScheduleCheckinPage'
import PaymentAndServicesPage from '../app/reception/patient/pages/PaymentAndServicesPage'

function ReceptionRoutes() {
  return (
    <Routes>
        {/* Reception */}
        <Route path="/reception/dashboard" element={<ReceptionDashboardPage />}></Route>
        <Route path="/reception/checkin" element={<ReceptionCheckinPage/>}></Route>
        <Route path="/reception/schedule-checkin" element={<ReceptionScheduleCheckinPage />}></Route>
        <Route path="/reception/token-payment" element={<TokenPaymentPage/>}></Route>
        <Route path="/reception/token-payment/:patientId" element={<TokenPaymentPage/>}></Route>
        <Route path="/reception/payment-services" element={<PaymentAndServicesPage/>}></Route>
        <Route path="/reception/collection-report" element={<ReceptionCollectionReportPage />}></Route>
        <Route path="/gatepass/dashboard" element={<GatepassDashboardPage /> }></Route>
        <Route path="/gatepass/generate" element={<GatepassGeneratePage /> }></Route>
        <Route path="/gatepass/details/:id" element={<GatepassDetailsPage /> }></Route>
        <Route path="/gatepass/visitor" element={<GatepassVisitorListPage /> }></Route>
    </Routes>
  )
}

export default ReceptionRoutes